import { createContext } from 'react';

export interface SharingModalContextProps {
    open: boolean;
    toggle: () => void;
}

export const SharingModalContext = createContext<SharingModalContextProps | null>(null);
